import { decoratedCa } from 'shared/mf-infrastructure/utils/analytics';

interface ITrackPanoramaCloseParams {
  objectType: string | null;
  blockType: string;
  profile: string | null;
}

export function trackPanoramaClose({ objectType, blockType, profile }: ITrackPanoramaCloseParams) {
  decoratedCa('eventSite', {
    action: 'close_sopr',
    category: 'Infrastructure',
    label: 'panorama',
    name: 'oldevent',
    page: {
      extra: {
        profile,
        object_type: objectType,
        block_type: blockType,
      },
    },
    useLastProducts: true,
  });
}
